module.exports = __webpack_public_path__ + "media/images/illustrations/illustration-3-cropped-0482e5ede7423b1973f042afa6347743.png";